module.exports = __webpack_public_path__ + "img/logo.747dfb9f.png";